import msg from "components/string-table";
import { Asterisk, Colors, Icon } from "main";

type DropDownProps = {
  id: string;
  label: string;
  value: string;
  onClick: () => void;
  stacked?: boolean;
  placeholder?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
};

/*
 * Wraps IonItem to display a select-type field's modal trigger and selected
 * values. Properly handles placeholder display on no selection and optionally
 * stacks label over displayed value.
 */
export function DropDown(props: DropDownProps) {
  const {
    id,
    label,
    value,
    stacked,
    placeholder,
    onClick,
    isDisabled = false,
    isRequired = false,
  } = props;
  const Label = () => (
    <span id={`${id}-dropdown`} style={{ fontWeight: "var(--swing-font-semibold" }}>
      {label}
    </span>
  );

  return (
    <div
      id={id}
      onClick={onClick}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        padding: "16px 0",
        borderBottom: `1px solid ${Colors.slate200}`,
        cursor: "pointer",
      }}
    >
      {stacked && value ? (
        <>
          <div>
            <div>
              <Label />
              {/* TODO styling and remove ionic components */}
              {isRequired && <Asterisk />}
            </div>
            <div>{value}</div>
          </div>
          {/* FIXME: when design system button is available */}
          <button type="button" disabled={isDisabled} style={{ backgroundColor: "transparent" }}>
            <Icon name="Chevron Down" color={Colors.blue500} />
          </button>
        </>
      ) : (
        <>
          <div>
            <Label />
            {isRequired && <Asterisk />}
          </div>
          <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <span>{value || placeholder || msg("LABEL_SELECT")}</span>
            {/* FIXME: when design system button is available */}
            <button
              type="button"
              disabled={isDisabled}
              onClick={onClick}
              style={{ backgroundColor: "transparent" }}
            >
              <Icon name="Chevron Down" color={Colors.blue500} />
            </button>
          </div>
        </>
      )}
    </div>
  );
}
